/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useMemo, useState } from 'react';
import { TGlobalContextProvider, TGlobalContext } from './GlobalContextTypes';
import { getIndivCookie, useCookie } from '../Cookies/cookieHandlers';
import { cookieExpiryTime } from 'components/account/config';
import { useVariant } from 'components/homePageJumbotronDemo/hooks/Heightvariant';

export const GlobalContext = createContext<TGlobalContext | null>(null);
export const GlobalContextProvider = ({ children }: TGlobalContextProvider) => {
  const [token, setToken] = useState(getIndivCookie('cToken'));
  const [userName, setUsername] = useState(getIndivCookie('cUserName'));
  const [tokenExpiry, setTokenExpiry] = useState(getIndivCookie('cTokenExpiry'));
  const [tenantId, setTenantId] = useState(getIndivCookie('cTenantId').split('_')[1]);
  const [facilityId, setFacilityId] = useState(getIndivCookie('cFacilityId').split('_')[0]);
  const [tenantSearchResponse, setTenantSearchResponse] = useState<any>();
  const [selectedLocationName, setSelectedLocationName] = useState(
    getIndivCookie('cSelectedLocationName'),
  );
  const [ledgerIdList, setLedgerIdList] = useState<any>();
  const [currSessionTime, setCurrSessionTime] = useState<any>();
  const [tenantLedgerList, setTenantLedgerList] = useState<any>();
  const [_, setCToken] = useCookie('cToken');
  const [__, setCTokenExpiry] = useCookie('cTokenExpiry');
  const [___, setCExpiryTime] = useCookie('cExpiryTime');
  const [____, setCUserName] = useCookie('cUserName');
  const [_____, setCTenantId] = useCookie('cTenantId');
  const [______, setCTenantName] = useCookie('cTenantName');
  const [tenantName, setTenantName] = useState(getIndivCookie('cTenantName') || {});
  const bodyHeight = useVariant();
  const now = new Date();
  const expires = new Date(now.setMinutes(now.getMinutes() + parseInt(cookieExpiryTime, 10)));
  const [activeLedgersList, setActiveLedgersList] = useState([]);
  const [loggedInSmsFacilityId, setLoggedInSmsFacilityId] = useState(
    getIndivCookie('cTenantId').split('_')[0],
  );
  const [alertModalInfo, setAlertModalInfo] = useState({
    showModal: false,
    currentUnitTypeData: {},
    type: '',
  });
  const [selectedPromoPlanId, setSelectedPromoPlanId] = useState<string>('');

  const providerValue = useMemo(
    () => ({
      token,
      setToken,
      userName,
      setUsername,
      tokenExpiry,
      setTokenExpiry,
      tenantId,
      setTenantId,
      tenantSearchResponse,
      setTenantSearchResponse,
      facilityId,
      setFacilityId,
      selectedLocationName,
      setSelectedLocationName,
      ledgerIdList,
      setLedgerIdList,
      currSessionTime,
      setCurrSessionTime,
      tenantLedgerList,
      setTenantLedgerList,
      setCToken,
      setCTokenExpiry,
      setCExpiryTime,
      setCUserName,
      setCTenantId,
      setCTenantName,
      bodyHeight,
      tenantName,
      setTenantName,
      expires,
      setActiveLedgersList,
      activeLedgersList,
      loggedInSmsFacilityId,
      setLoggedInSmsFacilityId,
      alertModalInfo,
      setAlertModalInfo,
      selectedPromoPlanId,
      setSelectedPromoPlanId,
    }),
    [
      token,
      userName,
      tokenExpiry,
      tenantId,
      facilityId,
      selectedLocationName,
      ledgerIdList,
      currSessionTime,
      tenantLedgerList,
      tenantName,
      activeLedgersList,
      loggedInSmsFacilityId,
      alertModalInfo,
      selectedPromoPlanId,
    ],
  );
  return <GlobalContext.Provider value={providerValue}>{children}</GlobalContext.Provider>;
};
